import React, { useCallback, useEffect, useState } from 'react';
import Styled from './Avaliations.styled';
import Select, { SelectOptionType } from 'components/Select';
import { GP_defaultOption, GP_optionOrderNota, GP_optionOrderType, GP_optionsOrder } from './OptionsFilter';
import AdminEditorStyled from 'pages/admin/components/pageEditors/AdminEditor.styled';
import { DatePicker } from 'antd';
import TableAvaliation from './tables/TableAvaliation';
import AdminRecursosCostumizados from 'core/http/service/admin/AdminRecursosCostumizados.service';
import AdminGestaoPaginaNotas from 'models/admin/AdminGestaoPaginaNotas';
import AdminPagination from 'pages/admin/components/pagination/AdminPagination';
import dayjs, { Dayjs } from 'dayjs';
import AdminGestaoPaginaMedia from 'models/admin/AdminGestaoPaginaMedia';
import Loading from 'components/Loading';

export interface IFilterAvaliacao {
    pagina: number;
    ordem: string;
    tipo: string;
    nota: string;
    por_pagina: number;
    data: Date | string | undefined;
    dataFim: Date | string | undefined;
}

export interface IFilterMedia {
    pagina: number;
    ordem: string;
    por_pagina: number;
    item?: string | number;
    conteudo?: string;
    media?: number | string;
}

const AvaliationsGestaoDePaginas = () => {
    const [loading, setLoading] = useState(false);
    const [avaliations, setAvaliations] = useState<AdminGestaoPaginaNotas[]>([]);
    const [avaliationsMedia, setAvaliationsMedia] = useState<AdminGestaoPaginaMedia[]>([]);

    const [totalPages, setTotalPages] = useState(1);
    const [isAvarage, setIsAvarage] = useState(false);
    const [itemsList, setItemsList] = useState<SelectOptionType[]>([]);

    const service = new AdminRecursosCostumizados();

    const [pathFilterMedia, setPathFilterMedia] = useState<IFilterMedia>({
        ordem: '',
        pagina: 1,
        por_pagina: 10,
        item: undefined,
        conteudo: undefined,
        media: undefined,
    });

    const [pathFilter, setArrayFilter] = useState<IFilterAvaliacao>({
        ordem: '',
        pagina: 1,
        tipo: '',
        nota: '',
        por_pagina: 10,
        data: undefined,
        dataFim: undefined,
    });

    const changePage = (page: number) => {
        isAvarage ? fetchAverage(page) : fetchAvaliations(page);
    };

    const fetchAverage = async (pagina?: number) => {
        setLoading(true);
        const { data } = await service.fetchGestaoDePaginaAverage({ ...pathFilterMedia, pagina: pagina ?? pathFilter.pagina });
        setAvaliationsMedia(data.rows ?? []);
        setTotalPages(data.totalPages);
        setLoading(false);
    };

    const fetchAvaliations = async (pagina?: number) => {
        setLoading(true);
        const dataFormat = pathFilter.data !== undefined ? dayjs(pathFilter.data).format('DD/MM/YYYY') : undefined;
        const dataFimFormat = pathFilter.dataFim !== undefined ? dayjs(pathFilter.dataFim).format('DD/MM/YYYY') : undefined;

        const { data } = await service.fetchGestaoDePaginaAvaliations({ ...pathFilter, pagina: pagina ?? pathFilter.pagina, data: dataFormat, dataFim: dataFimFormat });
        setAvaliations(data.rows ?? []);
        setTotalPages(data.totalPages);
        setLoading(false);
    };

    useEffect(() => {
        if (isAvarage) {
            fetchAverage();
        } else {
            fetchAvaliations();
        }
    }, [isAvarage]);

    useEffect(() => {
        if (!isAvarage) fetchAvaliations();
    }, [pathFilter]);

    useEffect(() => {
        if (isAvarage) {
            loadItemsList();
        }
    }, [isAvarage]);

    const loadItemsList = async () => {
        try {
            const { data } = await service.buscarListaResumidaItemAll();
            const options: SelectOptionType[] = (data || []).map((item: any) => ({
                label: item.titulo || item.nome || 'Item',
                value: item.id || item.codigo,
            }));
            setItemsList(options);
        } catch (error) {
            console.error('Erro ao carregar lista de itens:', error);
        }
    };

    useEffect(() => {
        if (isAvarage) fetchAverage();
    }, [pathFilterMedia]);

    const handleDateRangeChange = (dates: [Dayjs | null, Dayjs | null] | null) => {
        if (dates && dates[0] && dates[1]) {
            setArrayFilter({
                ...pathFilter,
                data: dates[0].toDate(),
                dataFim: dates[1].toDate(),
            });
        } else {
            setArrayFilter({
                ...pathFilter,
                data: undefined,
                dataFim: undefined,
            });
        }
    };

    const handleItemFilterChange = (selected: SelectOptionType) => {
        setPathFilterMedia({
            ...pathFilterMedia,
            item: selected.value,
            pagina: 1,
        });
    };

    const handleConteudoFilterChange = (value: string) => {
        setPathFilterMedia({
            ...pathFilterMedia,
            conteudo: value || undefined,
            pagina: 1,
        });
    };

    const handleMediaFilterChange = (selected: SelectOptionType) => {
        setPathFilterMedia({
            ...pathFilterMedia,
            media: selected.value,
            pagina: 1,
        });
    };

    const getMediaOptions = (): SelectOptionType[] => [
        { label: '★☆☆☆☆ 1 estrela', value: 1 },
        { label: '★★☆☆☆ 2 estrelas', value: 2 },
        { label: '★★★☆☆ 3 estrelas', value: 3 },
        { label: '★★★★☆ 4 estrelas', value: 4 },
        { label: '★★★★★ 5 estrelas', value: 5 },
    ];

    const handleClearFilters = () => {
        setPathFilterMedia({
            ordem: '',
            pagina: 1,
            por_pagina: 10,
            item: undefined,
            conteudo: undefined,
            media: undefined,
        });
    };

    return (
        <Styled.Container>
            <Styled.Title>Avaliações</Styled.Title>
            <Styled.ContainerRow style={{ marginBottom: '20px' }}>
                <Styled.SectionChip enabled={!isAvarage} onClick={() => setIsAvarage(false)}>
                    Notas
                </Styled.SectionChip>
                <Styled.SectionChip enabled={isAvarage} onClick={() => setIsAvarage(true)}>
                    Média notas
                </Styled.SectionChip>
            </Styled.ContainerRow>

            <Styled.ContainerRow style={{ marginBottom: '30px' }}>
                {!isAvarage ? (
                    <>
                        <Styled.RowRigth>
                            <span className="label-order">Ordenar por:</span>
                            <span className="span-select">
                                <Select
                                    width="200px"
                                    isSmall={true}
                                    itens={GP_optionsOrder}
                                    defaultValue={GP_optionsOrder[0]}
                                    onSelected={selected => {
                                        setArrayFilter({
                                            ...pathFilter,
                                            ordem: selected.value.toString(),
                                        });
                                    }}
                                />
                            </span>
                        </Styled.RowRigth>

                        <Styled.RowRigth>
                            <span className="label-order">Nota:</span>
                            <span className="span-select">
                                <Select
                                    width="200px"
                                    isSmall={true}
                                    itens={GP_optionOrderNota}
                                    defaultValue={GP_defaultOption}
                                    onSelected={selected => {
                                        setArrayFilter({
                                            ...pathFilter,
                                            nota: selected.value.toString(),
                                        });
                                    }}
                                />
                            </span>
                        </Styled.RowRigth>
                      
                        <Styled.ContainerRow>
                            <Styled.RowRigth>
                                <span className="label-order">Data:</span>
                                <div style={{ marginLeft: '5px' }}>
                                    <DatePicker.RangePicker
                                        placeholder={['Data início', 'Data fim']}
                                        format="DD/MM/YYYY"
                                        value={pathFilter.data && pathFilter.dataFim ? [dayjs(pathFilter.data), dayjs(pathFilter.dataFim)] : undefined}
                                        onChange={handleDateRangeChange}
                                        style={{ width: '280px' }}
                                    />
                                </div>
                            </Styled.RowRigth>
                        </Styled.ContainerRow>
                    </>
                ) : (
                    <>
                        <Styled.RowRigth>
                            <span className="label-order">Item:</span>
                            <span className="span-select">
                                <Select
                                    width="200px"
                                    isSmall={true}
                                    itens={itemsList}
                                    placeholder="Selecione um item"
                                    onSelected={handleItemFilterChange}
                                />
                            </span>
                        </Styled.RowRigth>

                        <Styled.RowRigth>
                            <span className="label-order">Conteúdo:</span>
                            <input
                                type="text"
                                placeholder="Digite o conteúdo"
                                style={{
                                    marginLeft: '5px',
                                    padding: '8px 12px',
                                    width: '200px',
                                    border: '1px solid #d9d9d9',
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                }}
                                onBlur={(e) => handleConteudoFilterChange(e.target.value)}
                            />
                        </Styled.RowRigth>

                        <Styled.RowRigth>
                            <span className="label-order">Média:</span>
                            <span className="span-select">
                                <Select
                                    width="200px"
                                    isSmall={true}
                                    itens={getMediaOptions()}
                                    placeholder="Selecione a média"
                                    onSelected={handleMediaFilterChange}
                                />
                            </span>
                        </Styled.RowRigth>

                        <Styled.RowRigth>
                            <button
                                onClick={handleClearFilters}
                                style={{
                                    marginLeft: '10px',
                                    padding: '8px 16px',
                                    backgroundColor: '#f5f5f5',
                                    border: '1px solid #d9d9d9',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: '#262626',
                                    transition: 'all 0.3s ease',
                                }}
                                onMouseEnter={(e) => {
                                    (e.target as HTMLButtonElement).style.backgroundColor = '#ececec';
                                    (e.target as HTMLButtonElement).style.borderColor = '#b3b3b3';
                                }}
                                onMouseLeave={(e) => {
                                    (e.target as HTMLButtonElement).style.backgroundColor = '#f5f5f5';
                                    (e.target as HTMLButtonElement).style.borderColor = '#d9d9d9';
                                }}
                            >
                                Limpar Filtros
                            </button>
                        </Styled.RowRigth>
                    </>
                )}
            </Styled.ContainerRow>
            {loading ? (
                <Loading />
            ) : (
                <React.Fragment>
                    <Styled.GridAvaliacao isAvarage={isAvarage}>
                        <Styled.GridHead>Título do Item</Styled.GridHead>
                        <Styled.GridHead>Título do conteúdo</Styled.GridHead>
                        {!isAvarage && <Styled.GridHead>Autor</Styled.GridHead>}
                        {!isAvarage && <Styled.GridHead>Data</Styled.GridHead>}
                        <Styled.GridHead>{isAvarage ? 'Média' : 'Nota'}</Styled.GridHead>
                        <Styled.GridHead>{isAvarage ? 'Total' : 'Ações'}</Styled.GridHead>

                        <TableAvaliation avaliations={avaliations} avarages={avaliationsMedia} isAverage={isAvarage} />
                    </Styled.GridAvaliacao>
                </React.Fragment>
            )}
            <AdminPagination onChangePage={changePage} total={totalPages} />
        </Styled.Container>
    );
};

export default AvaliationsGestaoDePaginas;
